import { landingClusters } from '../assets/landingClusters';

export const getLandingClusterByClusterId = (clusterId) =>
  landingClusters.find((lc) => lc.id === clusterId);

export const getLandingClusterByDisplayId = (displayId) =>
  landingClusters.find((lc) => lc.displayId === displayId);

export const getDisplayId = (clusterId) =>
  getLandingClusterByClusterId(clusterId)?.displayId;

export const getLogoUrl = (clusterId) =>
  getLandingClusterByClusterId(clusterId)?.logoUrl;
